"use strict";
/* globals module */
/**
 * @module meteringStatisticsRoute
 * @description Baasic Metering Statistics Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Statistics Route Definition Service to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var MeteringStatisticsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringStatisticsRoute, _super);
    function MeteringStatisticsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'metering/statistics/{category}/{?applicationIds,rateBy,from,to,names,moduleNames,statuses,endpoints,sources,page,rpp,sort,embed,fields}';
        return _this;
    }
    /**
     * Parses find metering route which can be expanded with additional options. Supported items are:
     * - `category` - The metering category.
     * - `applicationId` - The application identifier.
     * - `rateBy` - The sampling rate by minute,hour,day,week, month or year.
     * - `from` - The from date.
     * - `to` - The to date.
     * - `names` - The name of the resource inside the category in CSV format.
     * - `moduleNames` - The name of the resource inside the category in CSV format.
     * - `statuses` - The operation status in CSV format.
     * - `endpoints` - The back-end endpoint in CSV format.
     * - `sources` - The metering collector source in CSV format.
     * - `page` - A value used to set the page number, i.e. to retrieve certain metering subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the metering property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example meteringStatisticsRoute.find({category: '<category-name-or-id>'});
     **/
    MeteringStatisticsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    var _a;
    MeteringStatisticsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringStatisticsRoute);
    return MeteringStatisticsRoute;
}(common_1.BaseRoute));
exports.MeteringStatisticsRoute = MeteringStatisticsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
